import { useContext, useEffect } from "react"
import { AuthContext } from "src/providers/AuthProvider"
import { getWithExpiry } from "src/utils/localStorages"

const useAuthContext = () => {
  const { handleLogout, hasAuthenticated, ...rest } = useContext(AuthContext)
  const phoneNumber = getWithExpiry("phoneNumber")

  useEffect(() => {
    if (!phoneNumber && hasAuthenticated) {
      handleLogout()
    }
  }, [handleLogout, phoneNumber, hasAuthenticated])

  return { handleLogout, hasAuthenticated, ...rest }
}

export default useAuthContext
